// extracted by mini-css-extract-plugin
module.exports = {"howToChooseContent":"HowToChoose_howToChooseContent__EKwus"};